<app-my-account-navigation-ui [node]="node$ | async" [ngClass]="styleClass$ | async" class="flyout">
</app-my-account-navigation-ui>